import { render } from "./PatientSearchModal.vue?vue&type=template&id=fd005968"
import script from "./PatientSearchModal.vue?vue&type=script&lang=js"
export * from "./PatientSearchModal.vue?vue&type=script&lang=js"

import "./PatientSearchModal.vue?vue&type=style&index=0&id=fd005968&lang=scss"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__